import React from 'react';
import {
} from '@shopify/polaris';
import ProductFilterComponent from './ProductFilterComponent';
import ProductInventoryQuantityFilterComponent from './ProductInventoryQuantityFilterComponent';
import ProductVariantQuantityFilterComponent from './ProductVariantQuantityFilterComponent';
import ProductVariantTitleFilterComponent from './ProductVariantTitleFilterComponent';
import ProductVariantOptionFilterComponent from './ProductVariantOptionFilterComponent';
import ProductPriceFilterComponent from './ProductPriceFilterComponent';
import ProductCompareAtPriceFilterComponent from './ProductCompareAtPriceFilterComponent';
import ProductPricePercentageOfCompareAtPriceFilterComponent from './ProductPricePercentageOfCompareAtPriceFilterComponent';
import ProductConditionItem from './ProductConditionItem';
import ProductTagsFilterComponent from './ProductTagsFilterComponent';
import ProductCreatedAtFilterComponent from './ProductCreatedAtFilterComponent';
import ProductUpdatedAtFilterComponent from './ProductUpdatedAtFilterComponent';
import ProductStatusFilterComponent from './ProductStatusFilterComponent';
import ProductSmartCollectionFilterComponent from './ProductSmartCollectionFilterComponent';
import ProcessedByOperationFilterComponent from './ProcessedByOperationFilterComponent';
import TimeSinceProductCreatedFilterComponent from './TimeSinceProductCreatedFilterComponent';

class ProductConditionsComponent extends React.Component {
    state = {};

    render() {

        let conditionElements = this.props.filters.map((item, index) => {
            let valueOptions = null;
            let filterComponent = null;

            if (item.filterType === "productInventoryQuantity") {
                filterComponent = <ProductInventoryQuantityFilterComponent
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productVariantQuantity") {
                filterComponent = <ProductVariantQuantityFilterComponent
                    variants={this.props.variants}
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productStatus") {
                filterComponent = <ProductStatusFilterComponent
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productSmartCollection") {
                filterComponent = <ProductSmartCollectionFilterComponent
                    smartCollections={this.props.smartCollections}
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productProcessedByOperation") {
                filterComponent = <ProcessedByOperationFilterComponent
                    tagOperations={this.props.tagOperations}
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productVariantTitle") {
                filterComponent = <ProductVariantTitleFilterComponent
                    variants={this.props.variants}
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productPrice") {
                filterComponent = <ProductPriceFilterComponent
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productCompareAtPrice") {
                filterComponent = <ProductCompareAtPriceFilterComponent
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productPricePercentageOfCompareAtPrice") {
                filterComponent = <ProductPricePercentageOfCompareAtPriceFilterComponent
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productCreatedAt") {
                filterComponent = <ProductCreatedAtFilterComponent
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productUpdatedAt") {
                filterComponent = <ProductUpdatedAtFilterComponent
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "variantOption") {
                filterComponent = <ProductVariantOptionFilterComponent
                    valueOptions={this.props.selectedOptions}
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "productTagsNew") {
                filterComponent = <ProductTagsFilterComponent
                    tags={this.props.tags}
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (item.filterType === "timeSinceProductCreation") {
                filterComponent = <TimeSinceProductCreatedFilterComponent
                    onFilterUpdated={this.props.onFilterUpdated}
                    filter={item} />
            }

            if (filterComponent === null) {
                // TODO: to use onFilterUpdated
                filterComponent = <ProductFilterComponent
                    valueOptions={valueOptions}
                    tags={this.props.tags}
                    onValueChange={this.props.onValueChange}
                    onOperatorChange={this.props.onOperatorChange}
                    onFilterTypeChange={this.props.onFilterTypeChange}
                    filter={item} />
            }

            return <ProductConditionItem
                number={index + 1}
                error={this.props.errors[item.id]}
                onDelete={() => this.props.onFilterDelete(index)}>{filterComponent}</ProductConditionItem>
        }
        );

        return (
            <div>
                {conditionElements}
            </div>
        );
    }
}

ProductConditionsComponent.defaultProps = {
    errors: []
}

export default ProductConditionsComponent;
